import axios from 'axios'

export default {
  get (id) {
    return axios.get('participant/' + id)
  },
  add (participant) {
    return axios.post('participant', participant)
  },
  save (participant) {
    return axios.put('participant/' + participant.id, participant)
  },
  delete (participant) {
    return axios.delete('participant/' + participant.id)
  },
  sendConfirmationMail(participant) {
    return axios.post('participant/' + participant.id + '/confirmation')
  },
  createCertificate(participantId) {
    return axios.post('participant/' + participantId + '/certificate', null, { responseType: 'blob'})
  },
    getSpeed(participantId) {
      return axios.get('participant/' + participantId + '/speed')
    }
}
